import { render, staticRenderFns } from "./PiepkaartWfsLayer.vue?vue&type=template&id=578216a2&"
import script from "./PiepkaartWfsLayer.vue?vue&type=script&lang=js&"
export * from "./PiepkaartWfsLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
